// @flow

import * as React from 'react';
import PropTypes from 'prop-types';

import DisplayText from './DisplayText';

type Props = {
  themeColor?: string,
  children: React.Node
};

export function HeaderSecondText({ children, themeColor }: Props) {
  return (
    <DisplayText
      fontSize="16px"
      themeColor={themeColor || 'regularTextColor'}
      bold
      opacity={0.65}
      textAlign="center">
      {children}
    </DisplayText>
  );
}

HeaderSecondText.propTypes = {
  themeColor: PropTypes.string
};

export default HeaderSecondText;
